export default {"src":"/_next/static/media/money-back.a8c03687.svg","height":62,"width":60,"blurWidth":0,"blurHeight":0};